module.exports = __webpack_public_path__ + "img/welfare-5.f64d99d8.png";